import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const AuthLayout = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // If already authenticated, redirect to dashboard
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className="main-content">
      <div className="signUP-admin">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-lg-5 d-md-block d-none p-0">
              <div className="signUP-admin-left position-relative">
                <div className="signUP-overlay">
                  <img
                    className="svg signupTop"
                    src="img/svg/signupTop.svg"
                    alt="img"
                  />
                  <img
                    className="svg signupBottom"
                    src="img/svg/signupBottom.svg"
                    alt="img"
                  />
                </div>
                <div className="signUP-admin-left__content">
                  <div className="text-capitalize  mb-5 d-flex align-items-center   justify-content-center">
                    <img src="images/logo.png" />
                    {/* <a
                      className="wh-36 bg-primary text-white radius-md mr-10 content-center"
                      href="index"
                    >
                      a
                    </a>
                    <span className="text-dark">admin</span> */}
                  </div>
                  {/* <h1>Bootstrap 4 React Web Application</h1> */}
                </div>
                <div className="signUP-admin-left__imgs">
                  <img
                    className="img-fluid svg"
                    src="img/svg/signupIllustration.svg"
                    alt="img"
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-7 col-lg-7 col-md-7 col-sm-8">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
